<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps({
  lottery: {
    type: Object,
    required: true,
  },
})

const router = useRouter()

const lotteryId = computed(() => props.lottery.id ?? props.lottery.lottery_id)

const handleClick = () => {
  router.push(`/lottery/${lotteryId.value}`)
}
</script>

<template>
  <div class="lottery-card" @click="handleClick">
    <h3>{{ lottery.name }}</h3>
    <p class="description">{{ lottery.description || 'No description' }}</p>
    <p class="footer">Click to view details →</p>
  </div>
</template>

<style scoped>
.lottery-card {
  padding: 1.5rem;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: all 0.2s ease;
}

.lottery-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

h3 {
  color: #111827;
  margin: 0 0 0.75rem 0;
}

.description {
  color: #555;
  margin: 0 0 1rem 0;
  font-size: 0.95rem;
}

.footer {
  color: #2196f3;
  font-size: 0.9rem;
  margin: 0;
  font-weight: bold;
}
</style>

